module.exports = __webpack_public_path__ + "img/point-b.daf3d7dc.svg";